import { $api } from "../../../../services/request.config";
import { addParentTabNumberAction } from "../controls/addParentTabNumber.action";
import {
    addExtraVacationInformationCurrentRequest,
} from "../../currentRequestControls/addBloodDonationInformation.currentRequest";

export const getParentFullNameThunkAction = (props) => async (dispatch) => {
    console.log(props);
    try {
        const response = await $api(`v1/employees/${props.tabNumber}`);
        if (response.status === 200) {
            if (props.index !== null ) {
                // console.log();
                dispatch(addParentTabNumberAction({
                    parentInput: response.data.fullName,
                    indexOfParent: props.index,
                    inputfield: "fullName",
                    isParent: true,
                }));

            } else {
                dispatch(addExtraVacationInformationCurrentRequest({
                    stateProperty: "disabledChildCare",
                    field: "secondParent",
                    value: response.data,

                }));
                if(props.setInput) {
                    props.setInput(prev => ({
                        ...prev,
                        loading: false,
                    }));

                }


            }
        }
    } catch (error) {
        if (props.index !== null) {
            dispatch(addParentTabNumberAction({
                parentInput: "По данному табельному номеру не найдено ни одного сотрудника",
                indexOfParent: props.index,
                inputfield: "fullName",
                isParent: true,
            }));
        } else {
            if(props.setInput) {
                props.setInput(prev => ({
                    ...prev,
                    loading: false,
                    errorMessage: "По данному табельному номеру не найдено ни одного сотрудника",
                }));
            }

            // dispatch(addExtraVacationInformationCurrentRequest({
            //     stateProperty: "disabledChildCare",
            //     field: "secondParent",
            //     value: {
            //         ...currentRequest.disabledChildCare.secondParent,
            //         error: "По данному табельному номеру не найдено ни одного сотрудника",
            //         tabNumber: tabNumber,
            //     },
            // }));
        }
    }
};
